// extracted by mini-css-extract-plugin
export default {"list":"file-rejections_list__nVX8b"};